import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { PsyToolsId } from '../components/meet/tools-panel/types';

export interface IMeetActiveToolState {
  activeTool: PsyToolsId | 0;
}

const initialState: IMeetActiveToolState = {
  activeTool: 0,
};

export const activeToolStateSlice = createSlice({
  name: 'meetActiveToolState',
  initialState,
  reducers: {
    setActiveTool: (state, action: PayloadAction<PsyToolsId | 0>) => {
      state.activeTool = action.payload;
    },
  },
});

export const { setActiveTool } = activeToolStateSlice.actions;
export default activeToolStateSlice.reducer;
